import type { ReactNode } from 'react';

export default function SurveyValidationAlert({ children }: { children: ReactNode }) {
  return (
    <p role="alert" className="max-w-[min(100%,20rem)] text-center text-sm font-medium text-red-900">
      {children}
    </p>
  );
}
